import { isNil } from 'lodash';
import React, { memo, useCallback, useMemo, useRef } from 'react';
import { areEqualFields, onKeyDown } from 'utils/form';

const TextInput = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  required,
  endIcon,
  skipScrollingToField,
  lowerCase,
  ...props
}) => {
  const { label, type = 'text', style } = props;
  const { value, name } = field;
  const getClassNameForInput =
    touched[field.name] && errors[field.name] ? 'error-input default-input' : 'default-input';

  const fieldWrapperRef = useRef();
  const handleKeyDown = useCallback(
    (e) => {
      if (value) onKeyDown(e, fieldWrapperRef);
    },
    [value],
  );

  const fieldWrapperClassnames = useMemo(() => {
    let classes = 'field-wrapper';
    if (!skipScrollingToField) classes += ' scroll-to-field';
    return classes;
  }, [skipScrollingToField]);

  const inputValue = useMemo(() => {
    if (lowerCase) return value.toLowerCase();
    return !isNil(value) ? value : '';
  }, [lowerCase, value]);

  return (
    <div className={fieldWrapperClassnames} style={style} ref={fieldWrapperRef}>
      {endIcon ? <span style={{ position: 'absolute', right: '5px', bottom: '23px' }}>{endIcon}</span> : null}
      <input
        {...field}
        value={inputValue}
        type={type}
        onKeyDown={handleKeyDown}
        autoComplete="off"
        className={getClassNameForInput}
        id={name}
        required={required}
        maxLength="64"
        style={endIcon ? { paddingRight: '35px' } : {}}
      />
      <label className={value ? 'label-when-focused-input' : 'text-label'} htmlFor={name} id={`label-${name}`}>
        {label}
      </label>
      {errors[name] && touched[name] && <div className="error-text">{errors[name]}</div>}
    </div>
  );
};

export default memo(TextInput, (prevProps, nextProps) => areEqualFields(prevProps, nextProps, ['type']));
